import styled from 'styled-components';

export const LabelPickerPopover = styled.div`
    position: absolute;
    right: 24px;
    top: 24px;
    background: #282E33;
    border-radius: 3px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
    padding: 12px;
    width: 304px;
    z-index: 1000;
`;

export const LabelHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
`;

export const LabelList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 12px;
    max-height: 400px;
    overflow-y: auto;
`;

export const LabelItem = styled.div`
    padding: 8px;
    border-radius: 3px;
    background-color: ${props => props.color};
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    font-size: 14px;

    &:hover {
        filter: brightness(95%);
    }
`;

export const CreateLabelSection = styled.div`
    border-top: 1px solid #3B444C;
    padding-top: 12px;
    margin-top: 12px;
`;

export const ColorPicker = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin: 8px 0;
`;

export const ColorOption = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 4px;
    background-color: ${props => props.color};
    cursor: pointer;
    border: 2px solid ${props => props.selected ? '#B6C2CF' : 'transparent'};
    box-shadow: ${props => props.selected ? '0 0 0 2px #579DFF' : 'none'};

    &:hover {
        filter: brightness(95%);
    }
`;

export const LabelInput = styled.input`
    width: 100%;
    padding: 8px;
    border: 2px solid #3B444C;
    border-radius: 3px;
    margin-bottom: 8px;
    font-size: 14px;
    background: #22272B;
    color: #B6C2CF;

    &::placeholder {
        color: #8C9BAB;
    }

    &:focus {
        border-color: #579DFF;
        outline: none;
    }
`;

export const SectionTitle = styled.h4`
    margin: 0 0 8px 0;
    color: #B6C2CF;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    
    svg {
        margin-right: 8px;
    }
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #B6C2CF;
    width: 32px;
    height: 32px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
`;

export const Button = styled.button`
    padding: 6px 12px;
    background: #579DFF;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-size: 14px;
    margin-right: 8px;

    &:hover {
        background: #398BFF;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;